import { Order } from '../types/order';

/**
 * Calculates reserved inventory quantities from finalized orders
 *
 * This function aggregates the allocatedInventory field from all finalized orders
 * to determine how much inventory is reserved (allocated but not yet delivered).
 *
 * @param orders - All orders in the system
 * @returns Map of product name to total reserved quantity
 */
export function calculateReservedInventory(orders: Order[]): Map<string, number> {
  const reservedQuantities = new Map<string, number>();

  // Filter to finalized orders only (finalized = reserving inventory)
  // Note: We use isFinalized, not status === 'Completed', because finalized orders
  // reserve inventory even if they haven't been delivered yet
  const finalizedOrders = orders.filter(order => order.isFinalized);

  // Aggregate reserved quantities from all finalized orders
  finalizedOrders.forEach(order => {
    // Skip if no allocated inventory (shouldn't happen for finalized orders, but defensive)
    if (!order.allocatedInventory || order.allocatedInventory.length === 0) {
      return;
    }

    // Add each allocated item to the reserved quantities
    order.allocatedInventory.forEach(item => {
      const currentReserved = reservedQuantities.get(item.productName) || 0;
      reservedQuantities.set(item.productName, currentReserved + item.quantity);
    });
  });

  return reservedQuantities;
}
